// MSC MOD: Unminified and extended with countdown visibility listener
!function () {
  "use strict";

  customElements.get("slideshow-component") ||
    customElements.define(
      "slideshow-component",
      class extends HTMLElement {
        constructor() {
          super();
          this.flkty = null;
          this.flktyResizeEvent = () => { this.flkty.resize(); };
          this.getTallestSlideItemEvent = () => this.getTallestSlideItem();
          // MSC MOD START - listen for countdown slide visibility changes
          this.reinitAfterCountdownChange = this.reinitAfterCountdownChange.bind(this);
          // MSC MOD END
        }

        connectedCallback() {
          this.items = this.querySelectorAll("[data-slide]");
          this.getTallestSlideItem();
          this.initSlider();
          this.bindScrollButton();
          document.addEventListener("theme:resize:width", this.getTallestSlideItemEvent);
          // MSC MOD START - listen for countdown slide visibility changes
          this.addEventListener('theme:countdown:visibility-changed', this.reinitAfterCountdownChange);
          // MSC MOD END
        }

        initSlider() {
          // MSC MOD START - count only visible (non-countdown-hidden) slides
          const visibleItems = this.querySelectorAll('[data-slide]:not(.countdown--hide)');
          const slidesCount = visibleItems.length;
          // MSC MOD END

          const duration = parseInt(this.dataset.duration);
          const showPageDots = "true" === this.dataset.pageDots && slidesCount > 1;
          const showNavArrows = "true" === this.dataset.navArrows && slidesCount > 1;
          let autoplay = "true" === this.dataset.autoplay;
          if (autoplay) autoplay = duration;

          if (slidesCount > 1) {
            this.flkty = new window.theme.Flickity(this, {
              fade: true,
              cellSelector: "[data-slide]:not(.countdown--hide)", // MSC MOD - exclude hidden countdown slides
              autoPlay: autoplay,
              wrapAround: true,
              adaptiveHeight: true,
              setGallerySize: true,
              imagesLoaded: true,
              pageDots: showPageDots,
              prevNextButtons: showNavArrows,
              dragThreshold: 25,
              on: {
                ready: () => {
                  requestAnimationFrame(this.flktyResizeEvent);
                  document.addEventListener("theme:vars", this.flktyResizeEvent);
                  this.handleFirstSlideAnimation(true);
                },
                change: (index) => {
                  this.handleFirstSlideAnimation(false);
                  this.flkty.cells.forEach((cell, i) => {
                    cell.element.querySelectorAll("a, button").forEach((el) => {
                      el.setAttribute("tabindex", i === index ? "0" : "-1");
                    });
                    cell.element.querySelectorAll("text-highlight").forEach((el) => {
                      el.setTriggerAttribute(Boolean(i === index));
                    });
                  });
                },
              },
            });
            window.theme.flickitySmoothScrolling(this);
          } else if (slidesCount === 1) {
            // MSC MOD START - use first visible slide and add is-selected for CSS opacity rule
            const currentStyle = visibleItems[0].getAttribute('data-style') || visibleItems[0].getAttribute('style');
            visibleItems[0].classList.add('is-selected');
            // MSC MOD END
          }
        }

        // MSC MOD START - reinit Flickity when a countdown slide changes visibility
        reinitAfterCountdownChange() {
          const visibleSlides = this.querySelectorAll('[data-slide]:not(.countdown--hide)');
          const visibleCount = visibleSlides.length;

          if (this.flkty) {
            if (visibleCount <= 1) {
              document.removeEventListener("theme:vars", this.flktyResizeEvent);
              this.flkty.destroy();
              this.flkty = null;
              if (visibleCount === 1) {
                visibleSlides[0].classList.add('is-selected');
              }
            } else {
              this.flkty.reloadCells();
              this.flkty.resize();
            }
          } else if (visibleCount > 1) {
            this.initSlider();
          } else if (visibleCount === 1) {
            visibleSlides[0].classList.add('is-selected');
          }
        }
        // MSC MOD END

        getTallestSlideItem() {
          if (this.items.length <= 1) return;
          this.style.removeProperty("--item-min-h");
          const heights = [...this.items].map((e) => Math.floor(e.offsetHeight));
          const maxHeight = Math.max(...heights);
          const hasOriginalHeight = [...this.items].some((e) => e.classList.contains("original-height"));
          const hasOriginalHeightMobile = [...this.items].some((e) => e.classList.contains("original-height-mobile"));
          const hasMobileHeight = this.classList.contains("has-mobile-height");
          if (
            (window.theme.isDesktop() && !hasOriginalHeight) ||
            (window.theme.isMobile() && !hasOriginalHeightMobile && hasMobileHeight) ||
            (window.theme.isMobile() && !hasOriginalHeight && !hasMobileHeight)
          ) {
            if ([...this.items].some((e) => Math.floor(e.offsetHeight) !== maxHeight)) {
              this.style.setProperty("--item-min-h", `${maxHeight}px`);
            }
          }
        }

        handleFirstSlideAnimation(isFirstLoad = false) {
          if (!isFirstLoad) {
            this.classList.remove("slider--no-cached-images");
            this.classList.remove("slider--img-loaded");
            return;
          }
          const lazyImages = this.items[0].querySelectorAll(".lazy-image");
          const hasImgIn = this.classList.contains("img-in");
          if (lazyImages.length && !hasImgIn) {
            this.classList.add("slider--no-cached-images");
            const onTransitionEnd = (e) => {
              requestAnimationFrame(() => this.classList.add("slider--img-loaded"));
              lazyImages[0].removeEventListener("transitionend", onTransitionEnd);
            };
            lazyImages[0].addEventListener("transitionend", onTransitionEnd);
          }
        }

        bindScrollButton() {
          const scrollBtn = this.querySelector("[data-scroll-down]");
          if (scrollBtn) {
            scrollBtn.addEventListener("click", (e) => {
              e.preventDefault();
              const headerFixed = document.querySelector("[data-site-header]").classList.contains("site-header--fixed");
              const headerOffset = headerFixed ? 60 : 0;
              const scrollTo = parseInt(Math.ceil(this.offsetTop + this.offsetHeight - headerOffset));
              window.scrollTo({ top: scrollTo, left: 0, behavior: "smooth" });
            });
          }
        }

        disconnectedCallback() {
          document.removeEventListener("theme:resize:width", this.getTallestSlideItemEvent);
          document.removeEventListener("theme:vars", this.flktyResizeEvent);
          // MSC MOD START - remove countdown listener
          this.removeEventListener('theme:countdown:visibility-changed', this.reinitAfterCountdownChange);
          // MSC MOD END
        }
      }
    );
}();
